import React, { useContext, useEffect, useState } from 'react';
import { useTheme } from '@emotion/react';
import { AgendaContext } from '../../contexts/AgendaContext';
// Mui components
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
// Components
import HorizontalDivider from '../common/HorizontalDivider';
// Icons
import iconChevronDown from '../../assets/icons/icon_chevron-down.svg';
// Hooks
import { toCamelCaseAllWords } from '../../utils/Hooks/textFormatted';
import { resolveConsultorioConnectionBlockingReason } from '../../utils/Constants/consultorioConnectionBlocking';

function SeleccionContrato({ setLoadingVerificacionCD, onConsultorioConnectionBlocking }) {
  const theme = useTheme();
  const {
    contratoSeleccionado,
    setContratoSeleccionado,
    filialSeleccionada,
    setFilialSeleccionada,
    contratos,
    getConsultoriosWithContrato
  } = useContext(AgendaContext);

  const [expandedAccordion, setExpandedAccordion] = useState(false);

  useEffect(() => {
    const contratoGuardado = localStorage.getItem('contratoSeleccionado');
    const filialGuardada = localStorage.getItem('filialSeleccionada');
    const contratoFinal = contratoGuardado || contratos[0]?.contrato;
    const filialFinal = filialGuardada || contratos[0]?.filialDescripcion;

    if (contratoFinal) {
      localStorage.setItem('contratoSeleccionado', contratoFinal);
      setContratoSeleccionado(contratoFinal);
    }
    if (filialFinal) {
      localStorage.setItem('filialSeleccionada', filialFinal);
      setFilialSeleccionada(filialFinal);
    }
  }, []);

  const onClickContrato = async (filialDescripcion, contrato, estadoFilial) => {
    if (estadoFilial === false) return;

    setContratoSeleccionado(contrato);
    setFilialSeleccionada(filialDescripcion);
    setExpandedAccordion(false);
    localStorage.setItem('contratoSeleccionado', contrato);
    localStorage.setItem('filialSeleccionada', filialDescripcion);

    setLoadingVerificacionCD(true);

    try {
      const data = await getConsultoriosWithContrato(contrato);
      const reason = resolveConsultorioConnectionBlockingReason(data?.consultorioDigital);

      onConsultorioConnectionBlocking(reason, { showModal: true });
    } catch (error) {
      console.error('Error validando contrato CD:', error);
    } finally {
      setLoadingVerificacionCD(false);
    }
  };

  const renderFilial = (filialDescripcion, contrato, estadoFilial, index) => {
    return (
      <Box
        key={index}
        onClick={() => onClickContrato(filialDescripcion, contrato, estadoFilial)}
        sx={{
          cursor: !estadoFilial ? 'not-allowed' : 'pointer',
          '&:hover': { backgroundColor: '#fafbfd', borderRadius: '0 0 1rem 1rem' }
        }}>
        {index >= 1 && (
          <Box sx={{ paddingX: '1rem' }}>
            <HorizontalDivider />
          </Box>
        )}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            padding: '.7rem 1rem'
          }}>
          <Typography variant="legalM" sx={{ color: !estadoFilial && theme.palette.text.disabled }}>
            Filial {toCamelCaseAllWords(filialDescripcion)}
          </Typography>
          <Typography
            variant="callToAction"
            sx={{ color: !estadoFilial && theme.palette.text.disabled }}>
            Prestador {contrato}
          </Typography>
          {!estadoFilial && <Typography variant="bodyS">(No disponible por el momento)</Typography>}
        </Box>
      </Box>
    );
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        border: `2px solid ${theme.palette.backgroundSecondary.main}`,
        borderRadius: '1rem',
        width: '244px'
      }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', padding: '0rem 1.5rem' }}>
        <Typography variant="legalM">Filial {toCamelCaseAllWords(filialSeleccionada)}</Typography>
        <Typography variant="callToAction">Prestador {contratoSeleccionado}</Typography>
      </Box>
      <Accordion
        disableGutters
        expanded={expandedAccordion}
        elevation={0}
        sx={{
          '&:before': { height: '0px' },
          '& .MuiAccordionSummary-content': { margin: 0, flexGrow: 0 },
          width: '100%'
        }}>
        <AccordionSummary
          expandIcon={
            <Box
              component="img"
              sx={{ width: '16px', height: '16px' }}
              alt="img not found"
              src={iconChevronDown}
            />
          }
          onClick={() => setExpandedAccordion(!expandedAccordion)}
          sx={{
            minHeight: 0,
            width: '100%',
            padding: '0 1.5rem',
            justifyContent: 'start',
            gap: 0.8
          }}>
          <Typography
            variant="textLink"
            component="p"
            sx={{
              textDecoration: 'underline',
              color: theme.palette.primary.main,
              cursor: 'pointer'
            }}>
            Otros códigos
          </Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            border: `2px solid ${theme.palette.backgroundSecondary.main}`,
            marginTop: '0.4rem',
            position: 'absolute',
            backgroundColor: '#FFF',
            zIndex: 1,
            borderRadius: '1rem',
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            width: '244px',
            left: '-2px',
            padding: 0
          }}>
          {contratos?.map(({ filialDescripcion, contrato, estadoFilial }, index) =>
            renderFilial(filialDescripcion, contrato, estadoFilial, index)
          )}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}

export default SeleccionContrato;
